import { NavLink as Link} from 'react-router-dom';
import styled from 'styled-components'
import {FaBars} from 'react-icons/fa'

export const Nav =  styled.nav`
    background: #000;
    height: 10vh;
    display: flex;
    z-index 10;
`

export const Logo =  styled(Link)`
    display: flex;
    color: #fff;
    text-decoration: none;
    align-items: center;
    padding: 0 1rem;
    cursor: pointer;
    font-size: 28px;
    text-align: center;

    &:hover{
        transition all 0.2s ease-in-out;
        color: #15cdfc;
    }
`

export const NavLink =  styled(Link)`
    display: flex;
    color: #fff;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;
    transition all 0.2s ease-in-out;

    &:hover{
        transition all 0.2s ease-in-out;
        color: #15cdfc;
    }

    &.active{
        color: #15cdfc;
    }
`

export const Bars = styled(FaBars)`
    display: none;
    color: #fff;

    @media screen and (max-width: 1024px){
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 75%);
        font-size: 1.8rem;
        cursor: pointer;
    }
`

export const NavMenu = styled.div`
    display: flex;
    margin: auto;

    @media screen and (max-width: 1024px){
        display: none;
    }
`
export const NavBtn = styled.nav`
    display: flex;
    margin-left: auto;
    color: #fff;
    text-align: center;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-right: 20px;

    @media screen and (max-width: 1024px){
        display: none;
    }

    &:hover{
        transition all 0.2s ease-in-out;
        color: #15cdfc;
    }
`

export const NavBtnLink = styled(NavLink)`
    display: flex;    
    color: #fff;
    border: none;
    outline: none;
    cursor: pointer;
    transition all 0.2s ease-in-out;
    text-decoration: none;

    &:hover{
        transition all 0.2s ease-in-out;
        color: #15cdfc;
    }
`